/**
 * description: 选择设置视频封面的服务
 * author: Qian.qianchen
 * date: 2018-09-18
 */
"use strict";
angular.module("videoCoverImagesModule", [])
    .controller("videoCoverImagesCtrl", ["$scope", "editPictureService", "Upload", "$modalInstance", "item", "trsHttpService", "modalDialog", "$q", function($scope, editPictureService, Upload, $modalInstance, item, trsHttpService, modalDialog, $q) {
        initstatus();
        initData();
        /**
         * [initstatus description] 数据初始化
         * @return {[type]} [description]
         */
        function initstatus() {
            $scope.status = {
                navState: 'localImage',
                isShow: '',
                videoId: item.videoid,
                uploadImageSrc: "",
                editIcon: false,
                videoWidth: 0,
                videoHeight: 0
            }
            $scope.data = {
                keywords: '',
                localImageArr: [],
                selectImage: ""
            }
        }
        /**
         * [initData description]初始化获取数据
         * @return {[type]} [description]
         */
        function initData() {
            getVideoInfo().then(function() {
                // getCoverImage();
            });
        }
        /**
         * [getLocalImage description] 获取视频信息
         * @return {[type]} [description]
         */
        function getVideoInfo() {
            let deffer = $q.defer();
            var params = {
                "serviceid": "mlf_videoInterfacesEncapsulation",
                "methodname": "getVideoInfo",
                "id": $scope.status.videoId,
                "resourceType": 'video/mp4'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.localImageArr = data.DATA.vframeList.map(function(item, index) {
                    return {
                        src: item,
                        id: item + '_' + index
                    }
                });

                $scope.status.videoTitle = data.DATA.title;
                $scope.status.description = data.DATA.description;
                $scope.status.wide = data.DATA.wide;
                $scope.status.original = data.DATA.copyright;
                $scope.status.videoWidth = data.DATA.width;
                $scope.status.videoHeight = data.DATA.height;
                $scope.data.labelStrArr = data.DATA.tags;
                $scope.data.directorList = data.DATA.director;
                $scope.data.plannerList = data.DATA.planner;
                $scope.data.writerDirectorList = data.DATA.writerDirector;
                $scope.data.lateProducerList = data.DATA.lateProducer;
                $scope.data.compereList = data.DATA.compere;
                $scope.data.technicalDirectorList = data.DATA.technicalDirector;
                $scope.data.designerList = data.DATA.designer;
                $scope.data.reporterList = data.DATA.reporter;
                $scope.data.editorList = data.DATA.editor;
                $scope.data.producerList = data.DATA.producer;
                $scope.data.photographerList = data.DATA.photographer;
                $scope.data.cameramanList = data.DATA.cameraman;
                $scope.data.operatorList = data.DATA.operator;
                $scope.data.specialEffectsList = data.DATA.specialEffects;
                $scope.data.categoryId = data.DATA.categoryId;
                deffer.resolve();
            });
            return deffer.promise;
        }
        /**
         * [getCoverImage description] 获取视频封面
         * @return {[type]} [description]
         */
        function getCoverImage() {
            var params = {
                "serviceid": "mlf_videoInterfacesEncapsulation",
                "methodname": "getMediaFrame",
                "mediaId": $scope.status.videoId,
                "resourceType": 'video/mp4'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                for (let i = 0; i < $scope.data.localImageArr.length; i++) {
                    if (data.DATA.mediaFrameUrl == $scope.data.localImageArr[i]) {
                        $scope.data.selectImage = data.DATA.mediaFrameUrl;
                        $scope.status.navState = 'localImage';
                    }
                }
                if ($scope.data.selectImage == "") {
                    $scope.status.uploadImageSrc = data.DATA.mediaFrameUrl;
                    $scope.status.navState = 'uploadImage';
                }
            });
        }

        /**
         * [handleData description] 视频信息处理
         * @return {[type]} [description]
         */
        function handleData() {
            let videoData = {};
            if ($scope.status.navState == 'uploadImage') {
                videoData = {
                    'serviceid': 'mlf_videoInterfacesEncapsulation',
                    'methodname': 'saveVideo',
                    'VideoId': $scope.status.videoId,
                    'checkOut': 1,
                    "DocId": 0,
                    "name": '个人稿库',
                    "title": $scope.status.videoTitle,
                    "description": $scope.status.description,
                    "copyright": $scope.status.original,
                    "wide": $scope.status.wide,
                    "categoryId": $scope.data.categoryId,
                    // "stationId": $scope.data.station.curValue.id,
                    // "sourceId": $scope.data.sourceOptions.curValue.id,
                    "director": $scope.data.directorList,
                    "writerDirector": $scope.data.writerDirectorList,
                    "compere": $scope.data.compereList,
                    "planner": $scope.data.plannerList,
                    "designer": $scope.data.designerList,
                    "lateProducer": $scope.data.lateProducerList,
                    "technicalDirector": $scope.data.technicalDirectorList,
                    "reporter": $scope.data.reporterList,
                    "producer": $scope.data.producerList,
                    "cameraman": $scope.data.cameramanList,
                    "specialEffects": $scope.data.specialEffectsList,
                    "operator": $scope.data.operatorList,
                    "photographer": $scope.data.photographerList,
                    "editor": $scope.data.editorList,
                    "tags": angular.copy($scope.data.labelStrArr),
                    "cover": $scope.data.selectImage,
                    "resourceType": 'video/mp4'
                }
            } else {
                videoData = {
                    'serviceid': 'mlf_videoInterfacesEncapsulation',
                    'methodname': 'saveVideo',
                    'VideoId': $scope.status.videoId,
                    'checkOut': 1,
                    "DocId": 0,
                    "name": '个人稿库',
                    "title": $scope.status.videoTitle,
                    "description": $scope.status.description,
                    "copyright": $scope.status.original,
                    "wide": $scope.status.wide,
                    "categoryId": $scope.data.categoryId,
                    // "stationId": $scope.data.station.curValue.id,
                    // "sourceId": $scope.data.sourceOptions.curValue.id,
                    "director": $scope.data.directorList,
                    "writerDirector": $scope.data.writerDirectorList,
                    "compere": $scope.data.compereList,
                    "planner": $scope.data.plannerList,
                    "designer": $scope.data.designerList,
                    "lateProducer": $scope.data.lateProducerList,
                    "technicalDirector": $scope.data.technicalDirectorList,
                    "reporter": $scope.data.reporterList,
                    "producer": $scope.data.producerList,
                    "cameraman": $scope.data.cameramanList,
                    "specialEffects": $scope.data.specialEffectsList,
                    "operator": $scope.data.operatorList,
                    "photographer": $scope.data.photographerList,
                    "editor": $scope.data.editorList,
                    "tags": angular.copy($scope.data.labelStrArr),
                    "innerCover": $scope.data.selectImage,
                    "resourceType": 'video/mp4'
                }
            }
            return videoData;
        }
        /**
         * [cancel description]弹窗关闭
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        }
        /**
         * [selectImage description] 选择图片
         * @param  {[type]} item [description] 图片item
         * @return {[type]}      [description]
         */
        $scope.selectImage = function(item) {
            $scope.data.selectImage = item.id;
            $scope.status.uploadImageSrc = "";
        }
        /**
         * [navChange description] tab导航栏切换
         * @param  {[string]} nav [description] nav名称
         * @return {[type]}     [description]
         */
        $scope.navChange = function(nav) {
            $scope.status.navState = nav;
        }
        /**
         * [selectFile description] 上传本地图片
         * @param  {[array]} $files    [description] file数组
         * @param  {[object]} $file     [description] 
         * @param  {[array]} $newFiles [description] 本次上传的file数组
         * @return {[type]}           [description]
         */
        $scope.selectFile = function($files, $file, $newFiles) {
            var file = {};
            $scope.loadingPromise = Upload.upload({
                url: "/wcm/openapi/uploadImage",
                data: {
                    file: $newFiles[0]
                },
            }).then(function(resp) {
                if (resp.data.success) {
                    $scope.status.uploadImageSrc = resp.data.imgSrc;
                    $scope.data.selectImage = resp.data.imgName;
                } else {
                    file.error = resp.data.error;
                }
            }, function(resp) {
                if (resp.status == '413') {
                    file.error = '文件太大，不得大于30MB!';
                } else {
                    file.error = '未知错误!';
                }
            }, function(evt) {
                file.FILEINFO = "上传中"; 
            });
        }
        /**
         * [editPicture description] 编辑图片
         * @return {[type]} [description]
         */
        $scope.editPicture = function() {
            editPictureService.editPicture({
                PERPICURL: $scope.status.uploadImageSrc,
                APPFILE: $scope.data.selectImage
            }, "", function(data) {
                $scope.status.uploadImageSrc = data.imgSrc;
                $scope.data.selectImage = data.imgName;
            });
        };
        /**
         * [confirm description] 将选择的图片返回
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            if ($scope.status.navState === 'localImage') {
                var innerCover = '';
                for (var i = 0; i < $scope.data.localImageArr.length; i++) {
                    if ($scope.data.localImageArr[i].id == $scope.data.selectImage) {
                        innerCover = $scope.data.localImageArr[i].src;
                        break;
                    }
                }
                $modalInstance.close({ innerCover: innerCover, imgName: $scope.data.selectImage });
            } else {
                let params = {
                    'serviceid': 'mlf_videoInterfacesEncapsulation',
                    'methodname': 'videoUploadCover',
                    'VideoId': $scope.status.videoId,
                    'coverFileName': $scope.data.selectImage,
                    'libType': 100
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.CODE == '1') {
                        modalDialog.alertType('', data.MSG, 'error', false);
                    } else {
                        // modalDialog.alertType('', '视频封面图设置成功!', 'success', false);
                        $modalInstance.close({ cover: data.DATA.coverUrl, imgName: data.DATA.coverUrl });
                    }
                });
            }
        }
    }]);